// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of an incident:
 *   * NEW: Is still active
 *   * RESOLVED: Underlaying alarm has normalized. Incident needs no further user interaction
 *   * ACKNOWLEDGED: User has acknowledged (AuditConditionAcknowledge) the alarm — taking ownership.
 *   * CONFIRMED: User has confirmed (AuditConditionConfirm) the alarm — declaring it handled.
 *   * REPORTED: User has reported (AuditConditionReportedEventType — Essentim companion spec) the alarm — escalation/notification step, distinct from Ack.
 *   * CLOSED: Incident has been closed by user, underlaying alarm may be active or not
 *   * UPDATED: Generic operator/service audit event (e.g. alarm thresholds changed via the override API); detail is in `message`.
 * 
 * @export
 */
export const IncidentStatus = {
    New: 'NEW',
    Resolved: 'RESOLVED',
    Acknowledged: 'ACKNOWLEDGED',
    Confirmed: 'CONFIRMED',
    Reported: 'REPORTED',
    Closed: 'CLOSED',
    Updated: 'UPDATED'
} as const;
export type IncidentStatus = typeof IncidentStatus[keyof typeof IncidentStatus];


export function instanceOfIncidentStatus(value: any): boolean {
    for (const key in IncidentStatus) {
        if (Object.prototype.hasOwnProperty.call(IncidentStatus, key)) {
            if (IncidentStatus[key as keyof typeof IncidentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IncidentStatusFromJSON(json: any): IncidentStatus {
    return IncidentStatusFromJSONTyped(json, false);
}

export function IncidentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentStatus {
    return json as IncidentStatus;
}

export function IncidentStatusToJSON(value?: IncidentStatus | null): any {
    return value as any;
}

export function IncidentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): IncidentStatus {
    return value as IncidentStatus;
}

